<script>
import sourceFields from '../constants/sourcesFields';

export default {
  name: 'SourceFields',
  data() {
    return {
      allSourceFields: sourceFields.allSourceFields,
      allSourceFieldsWithDiscountBase: [],
    };
  },
  async created() {
    this.allSourceFieldsWithDiscountBase = await sourceFields.getSourceFieldsWithBaseDiscount();
  },
};
</script>
